"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const data_1 = require("../../../data");
const meetingCommentSchemaFields = (0, graphql_tag_1.default)`
  ${data_1.userPopupSchemaFields}
  ${data_1.documentSchemaFields}
  fragment meetingCommentSchemaFields on MeetingCommentGQLSchema {
    id
    body
    time
    owner {
      ...userPopupSchemaFields
    }
    target {
      ...userPopupSchemaFields
    }
    documents {
      ...documentSchemaFields
    }
    relatedComment {
      id
    }
  }
`;
const meetingQuestionSchemaFields = (0, graphql_tag_1.default)`
  ${data_1.userPopupSchemaFields}
  fragment meetingQuestionSchemaFields on MeetingQuestionGQLSchema {
    id
    status
    title
    description
    orderLevel
    questionType
    votingType
    owner {
      ...userPopupSchemaFields
    }
    speakers {
      ...userPopupSchemaFields
    }
    questionItems {
      id
      title
      description
      owner {
        ...userPopupSchemaFields
      }
    }
  }
`;
const meetingsList = (0, graphql_tag_1.default)`
  query meetings_meetingsList($filters: [FilterCoreInput], $before: Int, $after: Int, $first: Int, $last: Int) {
    meetings {
      meetingsList(filters: $filters, before: $before, after: $after, first: $first, last: $last) {
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        edges {
          node {
            id
            title
            status
            visitType
          }
        }
      }
    }
  }
`;
exports.default = meetingsList;